import { render, staticRenderFns } from "./pricing-details.vue?vue&type=template&id=77d52dbc"
import script from "./pricing-details.vue?vue&type=script&lang=js"
export * from "./pricing-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports